import styled from "styled-components";

const DjzReturnPageDisplay = styled.div`
  background: ${(p) => p.bgImg};
  background-size: cover;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .return-page {
    text-align: center;
    padding: 20px;
  }
  .spinner-wrap {
    .spinner {
      width: 40px;
      height: 40px;
      border: 3px solid rgba(255, 255, 255, 0.3);
      border-top-color: #fff;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
      margin: 0 auto 16px;
    }
    p {
      margin: 0;
      color: inherit;
    }
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export default DjzReturnPageDisplay;
